import { z } from 'zod';
import { FlaggedTransactionsSchema } from './flagged-transactions.schema.js';
import { TransactionBehaviorSchema } from './transaction-behavior.schema.js';
export const TransactionPatternsAnalysisSchema = z.object({
    behavior: TransactionBehaviorSchema.nullish(),
    flaggedTransactions: FlaggedTransactionsSchema.nullish()
}).meta({
    id: 'TransactionPatternsAnalysis'
});

//# sourceMappingURL=transaction-patterns-analysis.schema.js.map